export default "__VITE_ASSET__oF7ClC7X__"